import React, { Component } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import './App.scss';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Layout instance={this.props.instance}>
                <Routes>
                    {AppRoutes.map((route) => {
                        const { element, ...rest } = route;
                        return <Route key={route.path} {...rest} element={element} />;
                    })}
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </Layout>
        );
    }
}
